import $ from "jquery";

const methodiklist = () => {
    const init = () => {
        trigger()
    }

    const trigger = () => {
        const el = $('.js-methodik-list__img');
        if (el.length === 0) return;

        const onScroll = () => {
            const rect = el[0].getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) {
                execute();
                $(window).off('scroll', onScroll); // Remove listener after first execution
            }
        };

        $(window).on('scroll', onScroll);
        onScroll();
    }

    const execute = () => {
        const el = {
            main: '.js-methodik-list__img'
        }
        if ($(el.main).length === 0) return

        $(el.main).each(function () {
            const thisEach = $(this)
            const dataContent = thisEach.data('content');
            const dataDuration = thisEach.data('duration') ?? 5000;

            if (!dataContent) return;
            const items = dataContent;

            let currentIndex = 0;

            const showItem = () => {
                const itemParts = items[currentIndex].split('::');
                const [id, imgUrl] = itemParts;

                thisEach.parent().parent().find(`.mi-MethodikList`).removeClass('Active');
                thisEach.parent().parent().find(`.mi-MethodikList#${id}`).addClass('Active');
                thisEach.parent().parent().find(`.mi-MethodikList#${id}`)[0].style.setProperty('--duration', `${dataDuration}ms`);
                thisEach.find('img')[0].style.setProperty('--duration', `${dataDuration}ms`);
                thisEach.find('img').removeAttr('srcset')

                thisEach.find('img').removeClass('Active').addClass('Fading');
                setTimeout(() => {
                    thisEach.find('img').attr('src', imgUrl);
                    thisEach.find('img').removeClass('Fading').addClass('Active');
                }, 100);

                currentIndex = (currentIndex + 1) % items.length;
            };

            showItem();

            setInterval(showItem, dataDuration);
        })
    }
    init()
}

try {
    methodiklist()
} catch (error) {
    console.error('methodiklist', error)
}